import React, { Component } from 'react';
import { connect } from 'react-redux';
import {List, Map} from "immutable";
import {Icon, Radio} from "@blueprintjs/core";
import {isFloat} from 'validator';
import numeral from 'numeral';

// Componentes
import Select from "../../components/common/virtualized-select";
import VirtualizedTable from "../common/virtualized-table";

// Actions
import {getWarehouses, cleanWarehouses} from "../../actions/warehouses";
import {getStockList, cleanStockList} from "../../actions/stock";
import {getProducts, getProduct, cleanProducts} from "../../actions/products";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class AddMaterialDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            warehouse: -1,
            product: -1,
            quantity: 1,
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            cost_price: '',
            discount: '',
            comment: '',
            selectedProduct: Map({}),
            addedProducts: List([])
        }
    }
    componentDidMount() {
        this.props.onRef(this);
        this.props.getWarehouses({
            filters: { status: 'active' },
            projection: 'warehouse_code name'
        });

        if (this.props.materialTo === 'warehouse') {
            this.props.getProducts({
                filters: { status: 'active' },
                projection: 'product_code name desc category_labels'
            });
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
        this.props.cleanWarehouses();
        if (this.props.materialTo === 'project') {
            this.props.cleanStockList();
        } else {
            this.props.cleanProducts();
        }
    }

    calculateTotal = () => {
        return Math.round(
            isFloat(this.state.discount) && this.state.discount !== '' && this.state.discount > 0 
                ? (this.state.cost_price - this.state.cost_price * (this.state.discount / 100)) * this.state.quantity * 100
                : this.state.cost_price * this.state.quantity * 100
        ) / 100;
    }

    onAddButtonClick = () => {
        const registerMovements = [];
        if (this.props.materialTo === 'project') {
            for (const product of this.state.addedProducts) {
                registerMovements.push({
                    movement_type: 'Project',
                    movement_id: this.props.project.get('_id'),
                    origin_type: 'Warehouse',
                    origin_id: product.warehouse,
                    destination_type: 'Project',
                    destination_id: this.props.project.get('_id'),
                    product: product.product,
                    quantity: product.quantity,
                    price: product.cost_price,
                    discount: product.discount,
                    cost: product.cost,
                    comment: product.comment
                });
            }
        } else {
            registerMovements.push({
                movement_type: 'Project',
                movement_id: this.props.project.get('_id'),
                origin_type: 'Project',
                origin_id: this.props.project.get('_id'),
                destination_type: 'Warehouse',
                destination_id: this.state.warehouse,
                product: this.state.product,
                quantity: this.state.quantity
            });
        }
        this.props.registerMovement(registerMovements);
        this.props.onCloseModal();
    };

    onAddProduct = (product) => {
        this.setState({
            addedProducts: this.state.addedProducts.push({
                product_code: product.get('product_code'),
                cost_price: this.state.cost_price,
                quantity: this.state.quantity,
                discount: this.state.discount,
                product: this.state.product,
                warehouse: this.state.warehouse,
                cost: this.calculateTotal(),
                comment: this.state.comment
            }),
            cost_price: '',
            quantity: 1,
            discount: '',
            comment: '',
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })])
        }, this.validate);
    };

    validate = () => {
        let canSubmit;
        if (this.props.materialTo === 'project') {
            canSubmit = this.state.warehouse !== -1 && this.state.addedProducts.size > 0;
        }
        else {
            canSubmit = this.state.warehouse !== -1 &&
                this.state.product !== '' &&
                this.state.quantity !== '';
        }
        this.props.onCanSubmit(canSubmit);
    };

    render() {

        let movementRow = (<div></div>);
        let quantityRow = (<div></div>);
        let commentRow = (<div></div>);
        const projectColumn = (
            <div className="col">
                <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Proyecto</label>
                <input
                    className="form-control"
                    type="text"
                    value={`[${this.props.project.get('project_code') || ''}] ${this.props.project.get('name') || ''}`}
                    disabled={true}
                />
            </div>
        );
        const arrowColumn = (
            <div className="col-auto">
                <Icon style={{marginTop: 31}} icon="arrow-right" iconSize={24}/>
            </div>
        );

        // Stock Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 240,
            rowHeight: 40,
            strippedRows: false,
            conditionalRowStyle: [{
                dataField: '_id',
                operation: '=',
                value: this.state.product,
                style: {
                    backgroundColor: '#E8F1F7'
                }
            }],
            rowStyle: {
                color: '#676a6c'
            }
        };
        let tableData = List([]);
        let tableColumns = {
            product_code: {
                title: 'Código',
                columnType: 'text',
                dataField: 'product_code',
                width: 100,
                style: {},
                sortable: true,
                filterable: true
            },
            name: {
                title: "Nombre",
                columnType: 'text',
                dataField: 'name',
                width: 100,
                style: {},
                sortable: true,
                filterable: true
            },
            category_labels: {
                title: "Categorias",
                columnType: 'function',
                dataField: 'category_labels',
                width: 100,
                style: {},
                sortable: false,
                filterable: true,
                nodeContent: (category_labels) => {
                    category_labels = category_labels && category_labels.map( (category, i) => {
                        return i < category_labels.length -1 ? category + ', ' : category;
                    });

                    return category_labels;
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (productId) => {
                    return (
                        <Radio
                            style={{ marginTop: 10 }}
                            checked={ productId === this.state.product }
                            onChange={ () => {
                                this.props.getProduct(productId, {
                                    projection: '_id',
                                    populateRefs: true
                                });
                                this.setState({
                                    product: productId,
                                    selectedCostPrice: -1,
                                    selectedProduct: this.props.productList.find(product => product.get('_id') === productId)
                                }, this.validate);
                            }}
                        />
                    );
                }
            }
        };

        switch (this.props.materialTo) {
            case 'project':
                tableData = this.state.warehouse !== -1 ? this.props.productList : List([]);
                movementRow = (
                    <div className="row modal-row">
                        <div className="col">
                            <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Almacén</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.warehouses.toJS()}
                                value={this.state.warehouse}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(warehouse) => {
                                    if (warehouse && warehouse !== this.state.warehouse) {
                                        this.setState({
                                            warehouse: warehouse._id,
                                            product: -1
                                        });
                                        if (warehouse !== -1) {
                                            this.props.getStockList({
                                                filters: { warehouse: warehouse._id },
                                                populateRefs: true
                                            });
                                        }
                                    }
                                }}
                            />
                        </div>
                        {arrowColumn}
                        {projectColumn}
                    </div>
                );
                quantityRow = (
                    <div className="row modal-row">
                        <div className="col-3">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Últimos costes</label>
                            <Select
                                className="virtualized-select"
                                options={this.state.costPrices.toJS()}
                                value={this.state.selectedCostPrice}
                                labelKey="price"
                                valueKey="_id"
                                matchProp="price"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                onChange={(selectedCostPrice) => {
                                    if (selectedCostPrice) {
                                        if (selectedCostPrice._id !== -1) {
                                            let cost_price = selectedCostPrice.price;
                                            const discount = selectedCostPrice.discount.toString();
                                            if (isFloat(cost_price.toString())) {
                                                this.setState({
                                                    selectedCostPrice: selectedCostPrice._id,
                                                    cost_price
                                                });
                                            }
                                            if (isFloat(discount)) {
                                                this.setState({
                                                    discount
                                                });
                                            }
                                        }
                                        else {
                                            this.setState({ selectedCostPrice: selectedCostPrice._id });
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div className="col-2">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Coste ud. (€) *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.cost_price}
                                onChange={ (event) => {
                                    let cost_price = event.target.value;
                                    if (isFloat(cost_price) || cost_price === '') {
                                        this.setState({ cost_price }, this.validate );
                                    }
                                }}
                            />
                        </div>
                        <div className="col-2">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Descuento %</label>
                            <input
                                className='form-control'
                                type='text'
                                value={this.state.discount}
                                onChange={(event) => {
                                    const discount = event.target.value;
                                    if (isFloat(discount)) {
                                        this.setState({ discount });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-2">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Cantidad *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.quantity}
                                onChange={ (event) => {
                                    let quantity = event.target.value;
                                    if (isFloat(quantity) || quantity === '') {
                                        this.setState({ quantity }, this.validate );
                                    }
                                }}
                            />
                        </div>
                        <div className="col-3" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Total (€)</label>
                            <span style={{ lineHeight: '1.6', padding: '6px 0px', fontSize: '14px' }}>
                                {numeral(this.calculateTotal()).format()}
                            </span>
                        </div>
                    </div>
                );
                commentRow = (
                    <div className="row modal-row">
                        <div className="col-11">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Comentario</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.comment}
                                onChange={(event) => {
                                    this.setState({ comment: event.target.value });
                                }}
                            />
                        </div>
                        <div className="col-1" style={{ display: 'flex', alignItems: 'end' }}>
                            <button
                                className="btn btn-custom"
                                onClick={() => {
                                    this.onAddProduct(this.state.selectedProduct);
                                }}
                                disabled={!(this.state.warehouse !== -1 &&
                                    this.state.product !== '' &&
                                    this.state.cost_price !== '' &&
                                    this.state.quantity !== '')}
                            >
                                Añadir
                            </button>
                        </div>
                    </div>
                )
                break;
            case 'warehouse':
                tableData = this.state.products;
                movementRow = (
                    <div className="row modal-row">
                        {projectColumn}
                        {arrowColumn}
                        <div className="col">
                            <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Almacén</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.warehouses.toJS()}
                                value={this.state.warehouse}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(warehouse) => {
                                    if (warehouse) {
                                        this.setState({ warehouse: warehouse._id }, this.validate);
                                    }
                                }}
                            />
                        </div>
                    </div>
                );
                quantityRow = (
                    <div className="row modal-row">
                        <div className="col-4">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Cantidad *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.quantity}
                                onChange={ (event) => {
                                    let quantity = event.target.value;
                                    if (isFloat(quantity) || quantity === '') {
                                        this.setState({ quantity }, this.validate );
                                    }
                                }}
                            />
                        </div>
                    </div>
                );
                break;
            default:
                break;
        }

        // Add products table
        const addedProductsTableData = this.state.addedProducts;
        const addedProductsTableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 240,
            rowHeight: 40,
            strippedRows: false
        };
        const addedProductsTableColumns = {
            product_code: {
                title: "Código",
                columnType: 'text',
                dataField: 'product_code',
                width: 100,
                style: {},
                sortable: false,
                filterable: false
            },
            cost_price: {
                title: "Coste ud. (€)",
                columnType: 'number',
                dataField: 'cost_price',
                width: 100,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false
            },
            discount: {
                title: "Descuento %",
                columnType: 'function',
                dataField: 'discount',
                width: 100,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    return <div>
                        <span>{value || 0} %</span>
                    </div>
                }
            },
            amount: {
                title: "Cantidad",
                columnType: 'text',
                dataField: 'quantity',
                width: 100,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false
            },
            cost: {
                title: "Total (€)",
                columnType: 'number',
                dataField: 'cost',
                width: 100,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (productId) => {
                    return (
                        <Icon
                            className='cursor-pointer'
                            icon='trash'
                            title='Eliminar'
                            onClick={() => {
                                this.setState({ addedProducts: this.state.addedProducts.filter(product => product._id !== productId) });
                            }}
                        />
                    );
                }
            }
        }

        return (
            <div>
                {movementRow}
                { this.props.materialTo === 'warehouse' || this.state.warehouse !== -1
                    ? <div className="row modal-row" style={{ paddingTop: 10 }}>
                        <div className="col">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Producto</label>
                            <VirtualizedTable
                                tableSettings={tableSettings}
                                tableColumns={tableColumns}
                                tableData={tableData}
                            />
                        </div>
                    </div>
                    : null
                }
                { this.state.product !== -1
                    ? quantityRow
                    : null
                }
                {this.props.materialTo === 'project' && this.state.product !== -1 && commentRow}
                {this.props.materialTo === 'project' && (
                    <VirtualizedTable
                        tableSettings={addedProductsTableSettings}
                        tableColumns={addedProductsTableColumns}
                        tableData={addedProductsTableData}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const warehousesReducer = state.warehouses;
    const stockReducer = state.stock;
    const productsReducer = state.products;

    // Warehouses
    let warehouses = warehousesReducer.get('payload') || List([]);
    if (!(warehouses instanceof List)) warehouses = List([]);
    if (warehouses.size > 0) {
        warehouses = warehouses.map(warehouse => warehouse.set('select', `[${warehouse.get('warehouse_code')}] ${warehouse.get('name')}`));
    }
    warehouses = warehouses.insert(0, Map({ _id: -1, select: 'Selecciona un almacén' }));

    // Stock
    const stockList = stockReducer.get('payload') || List([]);
    let productList = List([]);

    stockList.map(stock => {
        return productList = productList.insert(productList.size, stock.get('product'));
    });

    // Products
    const products = productsReducer.get('payload') || List([]);

    return {
        warehouses,
        productList,
        products
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWarehouses: (query) => dispatch(getWarehouses(query)),
        getStockList: (query) => dispatch(getStockList(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        cleanWarehouses: () => dispatch(cleanWarehouses()),
        cleanStockList: () => dispatch(cleanStockList()),
        cleanProducts: () => dispatch(cleanProducts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMaterialDialog);


// WEBPACK FOOTER //
// ./src/components/dialogs/AddMaterialDialog.js